import type * as registerWin32Icons32px from './registerWin32Icons32px';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule32px: LazyModule<typeof registerWin32Icons32px> = new LazyModule(
    () => import(/* webpackChunkName: "Win32Icons32px" */ './registerWin32Icons32px'),
    { name: 'Win32Icons32px' }
);

export const lazyRegisterWin32Icons32px: LazyAction<
    typeof registerWin32Icons32px.registerWin32Icons32px,
    typeof lazyModule32px
> = new LazyAction(lazyModule32px, module => module.registerWin32Icons32px);
